<template>
  <!-- 开关次数 switched-->
  <div class="FilesManage">
    <div class="con">
      <div class="left-tree">
        <elAreaTree :dataList='dataList'></elAreaTree>
      </div>
      <div class="right-table">
        <div class="content">
          <div class="Files-table" :style="{'height':heights+'px'}">
            <el-table :data="tableData" stripe style="width: 100%" :height="heights - 20">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column label="序号" width="90" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="deviceNo" label="设备号" width="140"> </el-table-column>
              <el-table-column prop="bindAddressName" label="设备名称" min-width="350"> </el-table-column>
              <el-table-column prop="meterBase" label="开启次数" width="115"> </el-table-column>
              <el-table-column prop="meterBase2" label="关闭次数" width="115"> </el-table-column>
              <el-table-column prop="deductionFeeDay" label="操作时间" width="140">
              </el-table-column>
            </el-table>
          </div>
          <div class="divider-line"></div>
          <div class="paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
              :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>

        </div>
      </div>
    </div>
    <!-- 新增修改 -->


  </div>
</template>

<script>
  import elAreaTree from '@/components/module/newTree/elAreaTree.vue'
  import elIconBtn from '@/components/module/iconBtns.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      elAreaTree,
      elIconBtn
    },
    data () {
      var checkAge=(rule,value,callback) => {
        console.log(this.value,1111)
        if(!this.value) {
          return callback(new Error('请选择设备'));
        } else {
          callback();
        }

      };
      return {
        areaName: '',//区域名称
        value: '',
        treeData: {},
        areaId: '',//区域id
        heights: document.getElementById('app').clientHeight-200,//屏幕高度 - 导航栏高度
        seraname: "",
        tableData: [{
          deviceNo: 'ab3453435',
          bindAddressName: '测试开关',
          meterType: '表单',
          meterBase: '11',
          meterBase2: '10',
          deductionFeeDay: '2021-11-11',
          createTime: '2021-11-10',
        },
        {
          deviceNo: 'ee3423535',
          bindAddressName: '测试开关2',
          meterType: '表单',
          meterBase: '11',
          meterBase2: '12',
          deductionFeeDay: '2021-11-21',
          createTime: '2021-11-10',
        },
        {
          deviceNo: 'qb35644535',
          bindAddressName: '测试开关1',
          meterType: '表单',
          meterBase: '9',
          meterBase2: '10',
          deductionFeeDay: '2021-12-13',
          createTime: '2021-11-10',
        },
        {
          deviceNo: 'wb34534535',
          bindAddressName: '测试开关3',
          meterType: '表单',
          meterBase: '3',
          meterBase2: '2',
          deductionFeeDay: '2021-12-15',
          createTime: '2021-11-10',
        }],
        loading: false,
        total: 0,
        currentPage: 1,
        currentSize: 15,
        //弹窗
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增水表档案",
          edit: "编辑水表档案"
        },
        //新增修改对象
        temp: {
          "meterRunType": 1,
          'meterReadingType': "water",
        },
        //星号必填
        rules: {
          value: [
            {validator: checkAge,trigger: 'change'}
          ],
          meterBase: [
            {required: true,message: '请输入表底数',trigger: 'blur'}
          ],
          deductionFeeDay: [
            {required: true,message: '请输入抄表日期',trigger: 'blur'}
          ],
          meterType: [
            {required: true,message: '请输入表类型',trigger: 'blur'}
          ],
        },
        roleOptions: [],
        typeList: []
      };
    },

    computed: {
      deviceDataList () {
        // 尚未被配置为抄表的设备筛选
        var tree=this.$store.deviceStore.getters.getControlDeviceTree
        return tree
      },
      dataList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      nowArea () {
        var data=this.$store.cacheStore.state.setBuilding
        this.areaId=data.id
        this.areaName=data.label
        return data
      }

    },

    mounted () {

      this.getList()
      this.getTypeList() //获取表类型方式
      if(this.deviceDataList) {
        // this.treeData=this.deviceDataList
      }

    },
    watch: {
      dataList (v) {
        // console.log("侦听器",v);
      },
      nowArea (v) {
        this.getList()
        this.areaName=v.label
      }
    },

    methods: {
      // 导出
      exportWaterMeter () {
        // if(!this.areaId) {
        //   this.$message({showClose: true,message: '请选择区域',type: 'error'});
        //   return
        // }
        // areaId
        var params={
          areaId: 11,
          fileName: 11,
        }
        // console.log(,'11');
        window.open(DWSystemSetting.baseURL+'/water/exportWaterMeter?areaId='+this.areaId+'&fileName='+this.areaName,"_blank");
      },
      //  选择设备号
      handleChange (value) {
        this.temp.deviceNos=[value[value.length-1]]
        // console.log(value);
        // console.log(this.temp.deviceNos);
      },
      // 选择表类型
      typeListFn (v) {
      },
      // 点击树形返回
      getSchoolName (v) {
        this.areaId=v.id==this.areaId? '':v.id;
        this.areaName=v.label;
        this.getList()
      },
      //获取表类型方式
      getTypeList () {
        request({url: "/meterType/findMeterType",method: "post"}).then(res => { //负荷设备数
          if(res.code==200) {
            this.typeList=res.data
          }
        })

      },
      // 添加弹窗
      add_ed (v) {
        this.dialogStatus='add';
        this.value='';//清空设备号
        this.temp={
          "meterRunType": 1,
          'meterReadingType': "water",
        };
        if(this.areaId) {
          this.dialogVisible=true;
        } else {
          this.$message({showClose: true,message: '请选择区域',type: 'error'});
        }


        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var data=this.temp;
            data.areaId=this.areaId;
            request({url: "/water/saveWaterMeter.do",method: "post",data}).then(res => { //负荷设备数 
              console.log(res,'1111111');
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;//关闭弹窗
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })

            // saveIcCard(this.temp).then(res => {

            // })
          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp;
            data.areaId=this.areaId;
            request({url: "/water/saveWaterMeter.do",method: "post",data}).then(res => { //负荷设备数  
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;//关闭弹窗
                this.$message({showClose: true,message: '编辑成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('编辑失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        console.log(v,'v');
        this.temp=JSON.parse(JSON.stringify(v))
        this.value=[this.temp.deviceNo];//设备号  
        this.temp.deviceNos=[this.temp.deviceNo];//设备号 
        // this.temp.deviceNos=[20]
        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      //单个删除
      del_fn (row) {
        this.$confirm(`是否删除 ${row.deviceNo}号设备数据`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // var params=new FormData();
          // params.append("id",row.deviceNo);
          var params={deviceNos: row.deviceNo}
          request({
            url: "/water/deleteWaterMeter",method: "delete",params
          }).then(res => { //负荷设备数 

            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              if(res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error('删除失败');
              }
            }
          })

        }).catch(() => {
          // ...
        });
      },
      //批量导入
      saveExcel_fn (file) {
        let data=new FormData();
        data.append("file",file.raw);
        data.append("areaId",this.areaId);
        //  
        request({
          url: "/water/importWaterMeter",method: "post",data
        }).then(res => { //负荷设备数 
          if(res.code==200) {
            this.getList()
            this.$message({showClose: true,message: res.data,type: 'success'});
          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加失败')

          }
        })


      },
      //获取数据
      getList () {
        this.areaId=this.nowArea.id
        var params={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'areaId': this.areaId,
          'meterReadingType': 'water',
          deviceNo: this.seraname
        }
        this.loading=true
        request({url: "/water/getWaterMeterProfile.do",method: "get",params}).then(res => { //负荷设备数 
          this.loading=false
          if(res.code==200) {
            var d=res.data.dataResult.dataList;
            var a=[]
            for(const key in d) {
              if(d[key]) {
                d[key].map(v => {
                  a.push(v)
                })
              }
            }
            this.tableData=a;
            this.total=res.data.numberResult.total;
          }
        })
      },
      //分页功能 
      handleSizeChange (val) {
        this.currentSize=val;
        this.getList()
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.getList()
      }
    },
    filters: {
      //费率类型 ELECTRIC(电)  WATER(水) GAS(气)
      energyType (val) {
        if(val=='ELECTRIC') {
          return "电"
        } else if(val=='WATER') {
          return "水"
        } else {
          return "气"
        }
      },
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .FilesManage {
    display: flex;

    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .left-tree {
      width: 3rem;
      height: 100%;
      flex-shrink: 0;
      overflow: hidden;
      background-color: #fff;
      padding: 12px;
      padding-top: 20px;
      box-sizing: border-box;
      margin-right: 8px;
    }

    .right-table {

      width: calc(100% - 3.08rem);
      background-color: #fff;
      padding: 20px 20px 12px 20px;
      box-sizing: border-box;





      .Files-table {


        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

    }


    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }



  }
</style>